import moment from 'moment';
import { getVersion } from '../components/util/all';

export class Agent {
  id?: number;

  name: string;

  email: string;

  phone: string;

  clientId: number;

  logo: string | null;

  widthLogo: boolean;

  agentTours: any[];

  updatedAt: any;

  permissionId: number;

  agentPermission: any;

  constructor(model: any = {}) {
    this.id = model.id || null;
    this.name = model.name || null;
    this.email = model.email || null;
    this.phone = model.phone || null;
    this.clientId = model.clientId || null;
    this.logo = this.id && model.clientId && model.logo ? `${process.env.REACT_APP_AWS}/clients/${model.clientId}/agents/${this.id}/logo.png${getVersion(this.updatedAt)}` : null;
    this.widthLogo = model.widthLogo || false;
    this.agentTours = model.agentTours || [];
    this.updatedAt = model.updatedAt ? moment(model.updatedAt) : moment();
    this.permissionId = model.permissionId || null;
    this.agentPermission = model.agentPermission || null;
  }
}
